"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxFormed = exports["default"] = exports.StiloCheckbox = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../ThemeProvider");

var _Checkbox = _interopRequireDefault(require("react-bootstrap/lib/Checkbox"));

var _FormGroup = _interopRequireDefault(require("react-bootstrap/lib/FormGroup"));

var _Col = _interopRequireDefault(require("react-bootstrap/lib/Col"));

var _style = _interopRequireDefault(require("../style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormBaseWrapper = _interopRequireDefault(require("../FormBaseWrapper"));

var StiloCheckbox = function StiloCheckbox(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      checked = _ref.checked,
      id = _ref.id,
      value = _ref.value,
      name = _ref.name,
      handleChange = _ref.handleChange,
      type = _ref.type,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["classes", "label", "checked", "id", "value", "name", "handleChange", "type"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.FormBase, " stilo-form")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-horizontal"
  }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "stilo-input-horizontal"
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({}, props, {
    checked: checked,
    type: type,
    id: id,
    "data-ctrl-name": id,
    name: name,
    value: value,
    onChange: handleChange
  }), label))))));
};

exports.StiloCheckbox = StiloCheckbox;
StiloCheckbox.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  checked: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  id: _propTypes["default"].string,
  handleChange: _propTypes["default"].func,
  classes: _propTypes["default"].object
};
var ThemedStiloCheckbox = (0, _ThemeProvider.withStyles)(_style["default"])(StiloCheckbox);
exports["default"] = ThemedStiloCheckbox;

var CheckboxFormed = function CheckboxFormed(_ref2) {
  var props = (0, _extends2["default"])({}, _ref2);
  return /*#__PURE__*/_react["default"].createElement(_FormBaseWrapper["default"], (0, _extends2["default"])({
    Control: ThemedStiloCheckbox
  }, props));
};

exports.CheckboxFormed = CheckboxFormed;
//# sourceMappingURL=checkbox.js.map